import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useSession } from "./Session";
import DefaultLayout from "../layouts/DefaultLayout";
import StyleInjector from "./StyleInjector";
import LoginLayout from "../layouts/LoginLayout";
import Test from "../layouts/Test";

function SiteRouter(props) {
    const { firstLoad = false, templates = [] } = props
    const [session, ] = useSession();
    const [styleSheet, setStylesheet] = useState("")

    const drawRoutes = () => {
        // Routes for users not logged in
        if (!session.logged_in) {
            return (
                <>
                    <Routes>
                        <Route path="*" element={<LoginLayout dark={props.dark} />} />
                    </Routes>
                </>
            )
        }

        return (
            <>
                <Routes>
                    <Route path="/test" element={<Test />} />
                    <Route path="*" element={<>
                    <StyleInjector firstLoad={firstLoad} setStylesheet={setStylesheet} />
                    <DefaultLayout templates={templates} styleSheet={styleSheet} dark={props.dark} />
                    </>} />
                </Routes>
            </>
        )
    }
    return drawRoutes();
}

export default SiteRouter;
